import { Navigate, Outlet } from "react-router-dom";
import { useAppContext } from "@/shared/hooks/useAppContext";
import { useIsLawyer, getCachedLawyerStatus } from "@/shared/hooks/useIsLawyer";
import CircularProgress from "@/shared/components/CircularProgress";
import FullscreenLayout from "@/pages/layouts/FullScreenLayout";
import { LAWYER_ROUTES, POST_LOSS_ROUTES } from "@/shared/constants/paths";

export function LawyerRouteWrapper() {
  const { authUser, isLoading: appLoading } = useAppContext();
  const { isLawyer, isLoading: lawyerLoading } = useIsLawyer();

  const isLoading = appLoading || lawyerLoading;

  if (isLoading) {
    return (
      <FullscreenLayout>
        <CircularProgress />
      </FullscreenLayout>
    );
  }

  if (!authUser) {
    if (getCachedLawyerStatus()) {
      return (
        <FullscreenLayout>
          <CircularProgress />
        </FullscreenLayout>
      );
    }
    return <Navigate to={LAWYER_ROUTES.LOGIN} replace />;
  }

  if (!isLawyer) {
    if (getCachedLawyerStatus()) {
      return (
        <FullscreenLayout>
          <CircularProgress />
        </FullscreenLayout>
      );
    }
    return <Navigate to={POST_LOSS_ROUTES.OVERVIEW} replace />;
  }

  return <Outlet />;
}
